import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';

import ClaytonLogo from '@components/Shared/ClaytonLogo/ClaytonLogo';

import { formatShortDate } from '@utils/formatters';
import { NewsMentionCardStyles } from './NewsMentionCard.styled';
import { formatHttpsUrl } from '@utils/utils';

const NewsMentionCard = ({ newsMention }) => {
  const newsImageUrl =
    (newsMention &&
      newsMention?.newsImage &&
      formatHttpsUrl(newsMention.newsImage?.url + '?h=200&fm=webp')) ||
    '';
  const newsImageAltText =
    (newsMention && newsMention?.newsImage && newsMention.newsImage?.altText) ||
    newsMention?.newsHeadline;

  return (
    <NewsMentionCardStyles>
      <a href={newsMention.url} target="_blank" rel="noreferrer">
        <div className="news-media">
          {newsImageUrl ? (
            <Image
              alt={newsImageAltText}
              src={newsImageUrl}
              width={250}
              height={168}
            />
          ) : (
            <div className="news-media-none">
              <ClaytonLogo />
            </div>
          )}
        </div>
        <div className="news-details">
          <h6>{formatShortDate(newsMention?.publicationDate)}</h6>
          <h4>{newsMention?.newsPublisherName}</h4>
          <span className="caption">{newsMention?.newsHeadline}</span>
        </div>
      </a>
    </NewsMentionCardStyles>
  );
};

NewsMentionCard.propTypes = {
  newsMention: PropTypes.shape({
    newsHeadline: PropTypes.any,
    newsImage: PropTypes.shape({
      altText: PropTypes.any,
      url: PropTypes.string,
    }),
    newsPublisherName: PropTypes.any,
    publicationDate: PropTypes.any,
    url: PropTypes.any,
  }),
};

export default NewsMentionCard;
